import type { Age, Side } from './types/resources';

/**
 * Asientos numerados en sentido horario visto desde arriba. Mirando al centro de la mesa,
 * el siguiente asiento en sentido horario queda a tu IZQUIERDA.
 */
export function leftOf(seat: number, n: number): number {
  return (seat + 1) % n;
}

export function rightOf(seat: number, n: number): number {
  return (seat - 1 + n) % n;
}

export function neighborOf(seat: number, side: Side, n: number): number {
  return side === 'left' ? leftOf(seat, n) : rightOf(seat, n);
}

/** Dirección en la que se pasan las manos: izquierda en Eras I y III, derecha en Era II. */
export function passDirection(age: Age): Side {
  return age === 2 ? 'right' : 'left';
}
